import Image from "next/image";
import { getSiteLocaleFlagSrc, type SiteLocale } from "@/i18n/locales";
import { cn } from "@/utils/ui";

export function LanguageFlag({
	locale,
	className,
	priority = false,
}: {
	locale: SiteLocale;
	className?: string;
	priority?: boolean;
}) {
	return (
		<Image
			src={getSiteLocaleFlagSrc(locale)}
			alt=""
			aria-hidden="true"
			width={24}
			height={16}
			unoptimized
			priority={priority}
			className={cn(
				"h-4 w-6 shrink-0 rounded-[2px] object-cover shadow-[0_0_0_1px_rgba(255,255,255,0.08)]",
				className,
			)}
		/>
	);
}
